import { Mapper } from "../../../../../core/base";
import { DateTime, Duration } from "luxon";
import { JobDetailsWebEntity } from "./job-details-web-entity";
import { JobDetails } from "planning-portal-library/src/lib/core/domain";

export class JobDetailsWebRepositoryMapper extends Mapper<JobDetailsWebEntity, JobDetails> {
  mapFrom(param: JobDetailsWebEntity): JobDetails {
    return {
      jobId: param.jobId,
      planId: param.planId,
      startAddress: param.startAddress,
      endAddress: param.endAddress,
      jobNumber: param.jobNumber,
      startTerminalName: param.startTerminalName,
      endTerminalName: param.endTerminalName,
      startLatitude: param.startLatitude,
      startLongitude: param.startLongitude,
      endLatitude: param.endLatitude,
      endLongitude: param.endLongitude,
      distributionLaneId: param.distributionLaneId,
      distance: param.distance,
      duration: param.duration ? Duration.fromMillis(param.duration) : undefined,
      units: param.units,
      status:param.status,
      isScheduled: param.isScheduled,
      jobTemplate: param.jobTemplate, 
      jobColor : param.jobColor,
      vehicleType: param.vehicleType,
      distributionAreaId: param.distributionAreaId,
      distributionAreaName: param.distributionAreaName,
      locations: param.locations?.map(location => ({
        activityName : location.activityName,
        arrivalTime: location.arrivalTime ? DateTime.fromISO(location.arrivalTime.toString()) : undefined,
        departureTime: location.departureTime ? DateTime.fromISO(location.departureTime.toString()) : undefined,
        createdAt : location.createdAt,
        longitude: location.longitude,
        latitude: location.latitude,
        address: location.address,
        city: location.city,
        country: location.country,
        serviceToTime : location.serviceToTime,
        locationId: location.locationId,
        locationName: location.locationName,
        deliveryCapacityType3: location.deliveryCapacityType3,
        deliveryCapacityType2: location.deliveryCapacityType2,
        deliveryCapacityType1: location.deliveryCapacityType1,
        isScheduled: location.isScheduled,
        pickupCapacityType1: location.pickupCapacityType1,
        pickupCapacityType2: location.pickupCapacityType2,
        pickupCapacityType3: location.pickupCapacityType3,
        stopNumber: location.stopNumber,
        stopTime: location.stopTime,
        services: location.services,
        servicesCount: location.servicesCount,
        serviceTime: location.serviceTime,
        serviceFromTime:location.serviceFromTime,
        postalCode: location.postalCode,
        precedence: location.precedence,
        sequenceNumber: location.sequenceNumber,
        template: location.template,
        priority: location.priority,
        jobNumber: location.jobNumber,
        planName: location.planName,
        jobId: location.jobId,
        planId: location.planId,
        qualifications: location.qualifications,
        distributionLaneId: location.distributionLaneId,
        id: location.id,
        customData: location.customData,    
        isEndTerminal: location.isEndTerminal,
        isStartTerminal: location.isStartTerminal,
        prodId: location.prodId,
        productName: location.productName,
        tenantLocationId: location.tenantLocationId,
        segment: location.segment,
        openHours: location.openHours,
        productId: location.productId,
        hasUpdate:location.hasUpdate
      })),
      waypoints: param.waypoints,
      jobName: param.jobName,
      services: param.services?.map((service) => ({
        objectType: service.objectType,
        action: service.action,
        lcCode: service.lcCode,
        product: service.product,
        itemId: service.itemId,
        description : service.description,
        size: service.size,
        weight: service.weight,
        tenantId: service.tenantId,
        locationName: service.locationName,
        locationId: service.locationId,
        createdAt: service.createdAt,
        customData: service.customData
      })),
      startTime:param.startTime,
      endTime:param.endTime,
      estimatedStartTime: param.estimatedStartTime,
      estimatedEndTime: param.estimatedEndTime,
      startTerminalCity: param.startTerminalCity,
      startTerminalPostalCode: param.startTerminalPostalCode,
      endTerminalCity: param.endTerminalCity,
      endTerminalPostalCode: param.endTerminalPostalCode,
    };
  }

  mapTo(param: JobDetails): JobDetailsWebEntity {
    return {
      jobId: param.jobId,
      planId: param.planId,
      startAddress: param.startAddress,
      endAddress: param.endAddress,
      jobNumber: param.jobNumber,
      startLatitude: param.startLatitude,
      startLongitude: param.startLongitude,
      startTerminalName: param.startTerminalName,
      endTerminalName: param.endTerminalName,
      endLatitude: param.endLatitude,
      endLongitude: param.endLongitude,
      distance: param.distance,
      duration: param.duration?.toMillis(),
      units: param.units,
      distributionLaneId: param.distributionLaneId,
      isScheduled: param.isScheduled,
      status:param.status,
      jobTemplate: param.jobTemplate,
      jobColor : param.jobColor,
      vehicleType: param.vehicleType,
      distributionAreaId : param.distributionAreaId,
      distributionAreaName : param.distributionAreaName,
      locations: param.locations?.map(location => ({
        activityName : location.activityName,
        arrivalTime: location.arrivalTime ? DateTime.fromISO(location.arrivalTime.toString()) : undefined,
        createdAt : location.createdAt,
        longitude: location.longitude,
        latitude: location.latitude,
        address: location.address,
        city: location.city,
        country: location.country,
        locationId: location.locationId,
        locationName: location.locationName,
        deliveryCapacityType1: location.deliveryCapacityType1,
        deliveryCapacityType2: location.deliveryCapacityType2,
        deliveryCapacityType3: location.deliveryCapacityType3,
        isScheduled: location.isScheduled,
        pickupCapacityType1: location.pickupCapacityType1,
        pickupCapacityType2: location.pickupCapacityType2,
        pickupCapacityType3: location.pickupCapacityType3,
        stopNumber: location.stopNumber,
        stopTime: location.stopTime,
        services: location.services,
        servicesCount: location.servicesCount,
        serviceTime: location.serviceTime,
        serviceToTime : location.serviceToTime,
        serviceFromTime:location.serviceFromTime,
        postalCode: location.postalCode,
        precedence: location.precedence,
        sequenceNumber: location.sequenceNumber,
        template: location.template,
        priority: location.priority,
        jobNumber: location.jobNumber,
        planName: location.planName,
        jobId: location.jobId,
        planId: location.planId,
        qualifications: location.qualifications,
        distributionLaneId: location.distributionLaneId,
        id: location.id,
        customData: location.customData,
        isEndTerminal: location.isEndTerminal,
        isStartTerminal: location.isStartTerminal,
        hasUpdate: location.hasUpdate
      })),
      waypoints: param.waypoints,
      jobName: param.jobName,
      services: param.services?.map((service) => ({
        objectType: service.objectType,
        action: service.action,
        lcCode: service.lcCode,
        product: service.product,
        itemId: service.itemId,
        description : service.description,
        size: service.size,
        weight: service.weight,
        tenantId: service.tenantId,
        locationName: service.locationName,
        locationId: service.locationId,
        createdAt: service.createdAt,
        customData: service.customData
      })), 
      startTime:param.startTime,
      endTime:param.endTime,
      estimatedStartTime: param.estimatedStartTime,
      estimatedEndTime: param.estimatedEndTime,
      startTerminalCity: param.startTerminalCity,
      startTerminalPostalCode: param.startTerminalPostalCode,
      endTerminalCity: param.endTerminalCity,
      endTerminalPostalCode: param.endTerminalPostalCode,
    };
  }
}
